import {
  InfoWindow as GoogleMapsInfoWindow,
  InfoWindowProps as GoogleMapsInfoWindowProps
} from "@react-google-maps/api";

export type InfoWindowProps = GoogleMapsInfoWindowProps


export const InfoWindow = (props: InfoWindowProps) => {
  const { ...rest } = props;
  return <GoogleMapsInfoWindow {...rest} />;
};
